import { render } from "./TextComponent.vue?vue&type=template&id=35bf4828"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"

import "./TextComponent.vue?vue&type=style&index=0&id=35bf4828&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__